/**
 * 自定义事件
 */

let eventList = Object.create(null)

/**
 * 监听事件
 * @param {string} eventName 事件名称
 * @param {function} handler 事件触发时的回调函数
 * @return {number}
 */
const onEventHandler = (eventName, handler) => {
  return (
    (
      eventList[eventName.toLowerCase()] || (eventList[eventName.toLowerCase()] = [])
    ).push(handler) - 1
  )
}

/**
 * 取消监听事件
 * @param {string} eventName 事件名称
 * @param {number|function} handler
 */
const offEventHandler = (eventName, handler) => {
  const key = eventName.toLowerCase()
  if (eventList[key]) {
    eventList[key].splice(
      typeof handler === 'number'
        ? handler
        : eventList[key].indexOf(handler) >>> 0,
      1,
      () => { }
    )
  }
}

/**
 * 取消全部的事件监听
 * 如name不为空，则取消所有name事件的监听
 * @param {string} [eventName] 事件名称
 */
const offAllEventHandler = eventName => {
  eventName
    ? (eventList[eventName.toLowerCase()] = [])
    : (eventList = Object.create(null))
}

/**
 * 触发事件
 */
const emitEventHandler = (eventName, evt) => {
  (eventList[eventName.toLowerCase()] || []).map(handler => handler(evt))
}

/**
 * 监听页面激活事件
 * @param handler 页面激活时的回调
 * @param timeout 延迟监听的时长，默认为1000毫秒，防止页面加载时被执行
 */
export const $onResume = (handler, timeout = 1000) => {
  setTimeout(() => {
    onEventHandler('resume', handler)
  }, timeout)
}
export const $offResume = handler => offEventHandler('resume', handler)

export const $onPause = handler => onEventHandler('pause', handler)
export const $offPause = handler => offEventHandler('pause', handler)

const emitResumeEventHandler = () => {
  console.info('onResume running!')
  emitEventHandler('resume')
}
const emitPauseEventHandler = () => {
  console.info('onPause running!')
  emitEventHandler('pause')
}

/**
 * 页面激活时，由客户端调用
 */
window.onResume = window.onResume
  ? ($onResume(window.onResume), emitResumeEventHandler)
  : emitResumeEventHandler
/**
 * 离开页面时，由客户端调用
 */
window.onPause = window.onPause
  ? ($onPause(window.onPause), emitPauseEventHandler)
  : emitPauseEventHandler

export const $eventEmitter = {
  on: onEventHandler,
  off: offEventHandler,
  offAll: offAllEventHandler,
  emit: emitEventHandler
}

export default {
  install(Vue) {
    // 添加实例方法
    Vue.prototype.$eventEmitter = $eventEmitter

    Vue.prototype.$onResume = $onResume
    Vue.prototype.$offResume = $offResume

    Vue.prototype.$onPause = $onPause
    Vue.prototype.$offPause = $offPause
  }
}
